import React from 'react';
import noDataIcon from '../../../shared/assets/svg/NoData.svg';

const historyLabel = (type) => {
    if (type === 'owner_transfer') return 'Owner transfer';
    if (type === 'due_date_change') return 'Due date change';
    if (type === 'review') return 'Review';
    if (type === 'assign') return 'Assign';
    if (type === 'budget') return 'Budget';
    if (type === 'spend') return 'Spend';
    // One channel for both flow kinds — compliance reuses the permission type.
    if (type === 'permission') return 'Permission / Compliance';
    if (type === 'subtask_delete') return 'Subtask deleted';
    if (type === 'legal_case') return 'Court case';
    return type;
};

const HISTORY_TYPES = [
    'owner_transfer',
    'due_date_change',
    'review',
    'assign',
    'budget',
    'spend',
    'permission',
    'subtask_delete',
    'legal_case'
];

const formatDateTime = (dateString) => {
    if (!dateString) return '---';
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};

/**
 * Task history as a full-width panel. Purely presentational over `task.history`,
 * which already arrives with the task query — nothing is fetched here.
 */
const TaskHistoryPanel = ({ task }) => {
    const historyItems = [...(task?.history || [])]
        .filter((row) => HISTORY_TYPES.includes(row.type))
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    if (historyItems.length === 0) {
        return (
            <div className="rounded-2xl border border-dashed border-[#C7D3DE] bg-white flex flex-col items-center justify-center text-center p-12 gap-3">
                <img src={noDataIcon} alt="" className="w-40 h-auto max-h-32 object-contain opacity-50" />
                <p className="text-base font-semibold text-stone-600">No history yet</p>
            </div>
        );
    }

    return (
        <div className="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden">
            <div className="border-b border-gray-100 px-5 py-4">
                <h2 className="text-lg font-semibold text-gray-800">History</h2>
                <p className="mt-1 text-sm text-gray-500">
                    Newest first — every owner transfer, review, budget and permission change.
                </p>
            </div>
            <ul className="divide-y divide-gray-100">
                {historyItems.map((row) => (
                    <li key={row.id} className="px-5 py-4">
                        <div className="flex flex-wrap items-center gap-2">
                            <span className="inline-flex items-center rounded-full bg-[#E7F2EF] px-2.5 py-1 text-xs font-semibold text-[#2A565E]">
                                {historyLabel(row.type)}
                            </span>
                            <span className="text-xs text-gray-500">
                                {formatDateTime(row.createdAt)}
                                {row.user?.name ? ` · ${row.user.name}` : ''}
                            </span>
                        </div>
                        <p className="mt-2 text-sm text-gray-800">{row.message}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default TaskHistoryPanel;
